const stream = (state = {}, action) => {
  switch (action.type) {
    default: return state;
  }
};

export default stream;
